import type { OptionsItemType } from '@home/components/NewRegionSelect/type';
import { CHART_TYPE_ICON_MAP } from './chartTypeIconMap';

/**
 * charts 接口单个 dashboard → NewRegionSelect children。
 * 后端有 tabs 则按 tab 带 groupKey；否则用扁平 charts[]。
 */
export const mapDashboardChartChildren = (
  payload: any,
  optionValue: string,
): OptionsItemType[] => {
  const pairs: Array<{ chart: any; tab?: any; }> = [];

  if (payload?.tabs?.length) {
    for (const tab of payload.tabs) {
      for (const chart of tab.charts || []) {
        pairs.push({ chart, tab });
      }
    }
  } else {
    for (const chart of payload?.charts || []) {
      pairs.push({ chart });
    }
  }

  return pairs.map(({ chart, tab }) => ({
    value: `${optionValue}:${chart.chart_id}`,
    text: chart.name || chart.name_cn || '',
    textCN: chart.name_cn || chart.name || '',
    chartType: chart.chart_type || '',
    icon: chart.chart_type ? CHART_TYPE_ICON_MAP[chart.chart_type] : undefined,
    ...(tab && {
      groupKey: tab.tab_id,
      groupText: tab.tab_name,
      groupTextCN: tab.tab_name_cn || tab.tab_name,
      groupHeaderShowIcon: false,
    }),
  }));
};
